(function(){
'use strict';
if(window.__saWaCart)return;
window.__saWaCart=1;
var WA='971507594079';
var SEL='button[name="checkout"],input[name="checkout"],.cart__checkout-button,a[href^="/checkout"]';
var LABEL='Confirm Order on WhatsApp';
var NOTE='We confirm stock, freight and import duties with you on WhatsApp, then send a secure payment link.';
var TC_URL='/policies/terms-of-service';
var cached=null;

var css=document.createElement('style');
css.textContent=
  '.sa-tc-wrap{display:flex;align-items:flex-start;gap:8px;margin:12px 0 4px;font-size:12.5px;line-height:1.5;color:#3A352E;cursor:pointer;}'
 +'.sa-tc-wrap input{margin-top:2px;flex:0 0 auto;width:16px;height:16px;cursor:pointer;accent-color:#1A1713;}'
 +'.sa-tc-wrap a{text-decoration:underline;color:inherit;}'
 +'.sa-tc-locked{opacity:.5;}'
 +'@keyframes sa-tc-shake{10%,90%{transform:translateX(-1px)}20%,80%{transform:translateX(2px)}30%,50%,70%{transform:translateX(-4px)}40%,60%{transform:translateX(4px)}}'
 +'.sa-tc-shake{animation:sa-tc-shake .5s;}'
 +'.sa-tc-shake .sa-tc-cb{outline:2px solid #B3261E;outline-offset:2px;border-radius:2px;}'
 +'.sa-tc-btn-locked{opacity:.45 !important;cursor:not-allowed !important;}';
document.head.appendChild(css);

function money(cents,cur){
  try{return new Intl.NumberFormat('en-IN',{style:'currency',currency:cur||'INR',maximumFractionDigits:0}).format(cents/100);}
  catch(e){return String(Math.round(cents/100));}
}

function buildMsg(cart){
  var L=[];
  L.push('Hi Stone Atelier by SKL, I would like to confirm this order:');
  L.push('');
  for(var i=0;i<cart.items.length;i++){
    var it=cart.items[i];
    L.push((i+1)+'. '+it.product_title);
    var v=it.variant_title||'';
    if(v && v.toLowerCase()!=='default title'){L.push('   '+v);}
    L.push('   Qty '+it.quantity+'  -  '+money(it.line_price,cart.currency));
    L.push('');
  }
  L.push('Piece total: '+money(cart.total_price,cart.currency));
  L.push('(Excludes freight, insurance and import duties)');
  L.push('');
  L.push('Delivery country: ');
  L.push('City / pincode: ');
  L.push('');
  L.push('I confirm I have read and agree to the Terms & Conditions of Sale.');
  L.push('Please confirm availability, send me the landed price for my country, and share the payment link.');
  return L.join('\n');
}

function waUrl(cart){
  var t;
  if(cart && cart.items && cart.items.length){t=buildMsg(cart);}
  else{t='Hi Stone Atelier by SKL, I would like to place an order.';}
  return 'https://wa.me/'+WA+'?text='+encodeURIComponent(t);
}

function refresh(){
  try{
    fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
      .then(function(r){return r.json();})
      .then(function(c){cached=c;})
      .catch(function(){});
  }catch(e){}
}

function setLocked(btn,locked){
  if(locked){
    btn.setAttribute('disabled','disabled');
    btn.setAttribute('aria-disabled','true');
    btn.classList.add('sa-tc-btn-locked');
  }else{
    btn.removeAttribute('disabled');
    btn.removeAttribute('aria-disabled');
    btn.classList.remove('sa-tc-btn-locked');
  }
}

function ensureCheckbox(btn){
  if(!btn.parentNode)return null;
  var prev=btn.previousElementSibling;
  if(prev && prev.classList && prev.classList.contains('sa-tc-wrap')){
    return prev;
  }
  var wrap=document.createElement('label');
  wrap.className='sa-tc-wrap sa-tc-locked';
  var cb=document.createElement('input');
  cb.type='checkbox';cb.className='sa-tc-cb';
  var span=document.createElement('span');
  span.innerHTML='I have read and agree to the <a href="'+TC_URL+'" target="_blank" rel="noopener">Terms &amp; Conditions</a>';
  wrap.appendChild(cb);wrap.appendChild(span);
  btn.parentNode.insertBefore(wrap,btn);
  cb.addEventListener('change',function(){
    if(cb.checked){wrap.classList.remove('sa-tc-locked');}
    else{wrap.classList.add('sa-tc-locked');}
    setLocked(btn,!cb.checked);
  });
  return wrap;
}

function syncGate(btn){
  var wrap=ensureCheckbox(btn);
  if(!wrap)return;
  var cb=wrap.querySelector('.sa-tc-cb');
  if(!cb)return;
  setLocked(btn,!cb.checked);
}

function onClick(e){
  var t=(e.target&&e.target.closest)?e.target.closest(SEL):null;
  if(!t)return;
  var wrap=t.previousElementSibling;
  var cb=(wrap && wrap.classList && wrap.classList.contains('sa-tc-wrap'))?wrap.querySelector('.sa-tc-cb'):null;
  if(cb && !cb.checked){
    e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();
    setLocked(t,true);
    wrap.classList.remove('sa-tc-shake');
    void wrap.offsetWidth;
    wrap.classList.add('sa-tc-shake');
    wrap.scrollIntoView({behavior:'smooth',block:'center'});
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  if(cached){window.location.href=waUrl(cached);return;}
  var w=window.open('','_blank');
  fetch('/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'})
    .then(function(r){return r.json();})
    .then(function(c){cached=c;var u=waUrl(c);if(w){w.location.href=u;}else{window.location.href=u;}})
    .catch(function(){var u='https://wa.me/'+WA;if(w){w.location.href=u;}else{window.location.href=u;}});
}

function relabel(){
  var els=document.querySelectorAll(SEL);
  for(var i=0;i<els.length;i++){
    var el=els[i];
    syncGate(el);
    if(el.getAttribute('data-sa-wa')==='1')continue;
    el.setAttribute('data-sa-wa','1');
    if(el.tagName==='INPUT'){
      if(/check ?out/i.test(el.value||'')){el.value=LABEL;}
    }else{
      if(/check ?out/i.test(el.textContent||'')){el.textContent=LABEL;}
    }
    if(el.parentNode && !el.parentNode.querySelector('.sa-wanote')){
      var n=document.createElement('p');
      n.className='sa-wanote';
      n.style.cssText='margin:10px 0 0;font-size:12.5px;line-height:1.5;color:#5A554D;text-align:center;';
      n.textContent=NOTE;
      el.parentNode.insertBefore(n,el.nextSibling);
    }
  }
}

var deb;
function boot(){
  relabel();refresh();
  setTimeout(relabel,300);setTimeout(relabel,1000);setTimeout(relabel,2000);
  document.addEventListener('click',onClick,true);
  new MutationObserver(function(){
    relabel();
    clearTimeout(deb);deb=setTimeout(refresh,400);
  }).observe(document.body,{childList:true,subtree:true});
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();